export const SECTION_ROW_LIMIT = 10;

export function isSeeAllRowItem(item) {
  return Boolean(item?.__seeAll);
}

export function buildSectionRowItems(items, { canSeeAll = false, markerId = 'section' } = {}) {
  const source = Array.isArray(items) ? items : [];
  const visibleItems = canSeeAll ? source.slice(0, SECTION_ROW_LIMIT) : source;

  if (!canSeeAll || source.length <= SECTION_ROW_LIMIT) {
    return visibleItems;
  }

  return [
    ...visibleItems,
    { id: `see-all-${markerId}`, __seeAll: true },
  ];
}
